<template>
    <!-- https://techsch.com/tutorials/email-verification-laravel-fortify -->

    <Head title="Verification Email" />
    <div class="register-page">
        <div class="content">
            <div class="card py-4">
                <div class="card-body">
                    <!-- Inform user after click resend verification email button is successful -->
                    <div v-if="status" class="alert alert-success text-center">Tautan verifikasi email baru telah
                        dikirim ke email
                        Anda!</div>
                    <div class="text-center mb-5">
                        <!-- Instructions for new users -->
                        <h3>Verifikasi alamat email</h3>
                        <p>Anda harus memverifikasi alamat email Anda untuk mengakses halaman ini.</p>
                    </div>
                    <form @submit.prevent="submit" class="text-center">
                        <button type="submit" class="btn btn-primary" :disabled="form.processing">Mengirim ulang email verifikasi</button>
                    </form>
                </div>
                <!-- Optional: Add this link to let user clear browser cache -->
                <p class="mt-3 mb-0 text-center"><small>Ada masalah dengan proses verifikasi atau salah memasukkan
                        email?
                        <br>Silahkan mendaftar dengan alamat email
                        <Link href="/register-retry">lainnya</Link>.
                    </small></p>
            </div>
        </div>
    </div>
</template>
  
<script>
import { Head } from '@inertiajs/vue3'

export default {
    components: {
        Head,
    },
    props: {
        status: String,
    },
    data() {
        return {
            form: this.$inertia.form({
            }),
        }
    },
    methods: {
        submit() {
            this.form.post('/email/verification-notification')
        },
    }
}
</script>
  
<style>
.content {
    max-width: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
}
</style>

<style>
.register-page {
  /* The image used */
  /* background-image: url("/background.jpg"); */
  background: rgba(0, 0, 0, .65) url("/default/background.jpg");
  background-blend-mode: darken;

  /* Control the height of the image */
  min-height: 380px;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
</style>
